import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';

// Administration Components
import { AreasComponent } from './areas/areas.component';
import { AreaDetailComponent } from './areas/area-detail/area-detail.component';
import { AdministrationDataComponent } from './administration-data/administration-data.component';
import { ProfileComponent } from './profile/profile.component';
import { ModalProfileComponent } from './profile/modal-profile/modal-profile.component';
import { ProvidersComponent } from './providers/providers.component';
import { ProvidersDetailComponent } from './providers/providers-detail/providers-detail.component';
import { UsersComponent } from './users/users.component';
import { UserDetailComponent } from './users/user-detail/user-detail.component';

const AdministrationComponents = [
  AreasComponent,
  AreaDetailComponent,
  AdministrationDataComponent,
  ProfileComponent,
  ModalProfileComponent,
  ProvidersComponent,
  ProvidersDetailComponent,
  UsersComponent,
  UserDetailComponent
];

@NgModule({
  declarations: AdministrationComponents,
  imports: [SharedModule],
  exports: AdministrationComponents
})
export class AdministrationModule { }
